import httpService from '../httpService';
import { ExternalCalendar } from '../../models/calendarConnection.model';
import { EventType, NotificationSettings } from '../../types/event';
import { store } from '../../redux/store';
import { RootState } from '../../redux/reducers';

async function importEvent(
  icsContent: string,
  participantsIds: number[] = [],
  externalInvites: { externalMemberId: number }[] = [],
  inviteAll = true,
  inviteActive = false,
  eventType?: EventType,
  notificationSettings?: NotificationSettings,
  attendanceRequired?: boolean
): Promise<void> {
  const { selectedCommunity } = (store.getState() as RootState).application;

  const formData = new FormData();
  formData.append('icsFile', new Blob([icsContent], { type: 'text/calendar' }), 'events.ics');
  formData.append('participantsIds', JSON.stringify(participantsIds));
  formData.append('externalInvites', JSON.stringify(externalInvites));
  formData.append('inviteAll', String(inviteAll));
  formData.append('inviteActive', String(inviteActive));
  if (eventType) {
    formData.append('eventType', eventType);
  }
  if (notificationSettings) {
    formData.append('notificationSettings', JSON.stringify(notificationSettings));
  }
  if (attendanceRequired !== undefined) {
    formData.append('attendanceRequired', String(attendanceRequired));
  }

  return httpService.post(
    `/networks/communities/${selectedCommunity}/calendar-connection/import`,
    formData,
  );
}

async function createExternalCalendar(
  url: string,
  eventType?: EventType,
  notificationSettings?: NotificationSettings,
  participantsIds?: number[],
  externalInvites?: { externalMemberId: number }[],
  inviteAll?: boolean,
  inviteActive?: boolean,
  attendanceRequired?: boolean
): Promise<number> {
  const { selectedCommunity } = (store.getState() as RootState).application;
  const { data } = await httpService.post(`/networks/communities/${selectedCommunity}/calendar-connection/external`, {
    url,
    eventType,
    notificationSettings,
    participantsIds,
    externalInvites,
    inviteAll,
    inviteActive,
    attendanceRequired
  });
  return data;
}

async function deleteExternalCalendar(id: string | number): Promise<void> {
  const { selectedCommunity } = (store.getState() as RootState).application;
  const { data } = await httpService.delete(`/networks/communities/${selectedCommunity}/calendar-connection/external/${id}`);
  return data;
}

async function getExternalCalendars(): Promise<ExternalCalendar[]> {
  const { selectedCommunity } = (store.getState() as RootState).application;
  const { data } = await httpService.get(`/networks/communities/${selectedCommunity}/calendar-connection/external`);
  return data;
}

async function fetchExternalCalendar(id: string | number): Promise<any> {
  const { selectedCommunity } = (store.getState() as RootState).application;
  const { data } = await httpService.put(`/networks/communities/${selectedCommunity}/calendar-connection/external/${id}/sync`);
  return data;
}

export default {
  importEvent,
  createExternalCalendar,
  deleteExternalCalendar,
  getExternalCalendars,
  fetchExternalCalendar
}
